import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { AdminService } from 'src/app/admin/admin.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getLanguages } from 'src/environments/environment';

@Component({
    selector: 'app-home-main-banner',
    standalone: true,
    imports: [CarouselModule, RouterLink, CommonModule],
    templateUrl: './home-main-banner.component.html',
    styleUrls: ['./home-main-banner.component.scss']
})
export class HomeMainBannerComponent implements OnInit {
    
    homeSlides: OwlOptions = {
		loop: true,
		nav: true,
		dots: true,
		autoplayHoverPause: true,
		autoplay: true,
		items: 1,
    autoHeight: true,
    rtl: false,
		navText: [
			"<i class='bx bx-chevron-left'></i>",
			"<i class='bx bx-chevron-right'></i>"
		]
    }

  sliders: any
  imageUrl

  constructor(private publicService: PublicServiceService, private adminService: AdminService,
  ) {
    this.imageUrl = this.publicService.IMAGE_URL
    if (Number(localStorage.getItem("language")) == getLanguages().FA_IR) {
      this.homeSlides["rtl"] = true
    }
    console.log("homeSlides", localStorage.getItem("language"), this.homeSlides["rtl"]);

  }

  ngOnInit(): void {

    this.getSliders()
  }

	
  getSliders() {
    this.publicService.getRecordHome(this.publicService.SLIDER_URL).subscribe({
      next: (res) => {
        this.sliders = res

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}